import { createSlide } from "../slidesOps/createSlide";
import LogoSVG from "../../../icons/logo.svg";
export function restingSlide() {
    return createSlide({
        center: true,
        html: LogoSVG,
        background: { color: null },
    }, "welcome");
}
